export function resolveCareTeamScope(periods, programid, now = Date.now()) {
  const eligible = new Set(['active', 'pending_unalignment', 'pending_alignment', 'pending_eligibility']);
  const groups = new Map();
  for (const cp of periods) {
    if (String(cp.programid ?? '') !== String(programid)) continue;
    const uid = String(cp.withings_user_id || '');
    if (!uid) continue;
    const start = Date.parse(cp.start_date || '');
    if (Number.isFinite(start) && start > now) continue;
    if (!groups.has(uid)) groups.set(uid, []);
    groups.get(uid).push(cp);
  }
  const selected = [], ambiguous = [];
  for (const [uid, cps] of groups) {
    const open = cps.filter(cp => eligible.has(cp.status));
    if (!open.length) continue;
    if (open.length !== 1) { ambiguous.push(uid); continue; }
    const current = open[0];
    const start = Date.parse(current.start_date || '');
    // A documented ended episode can precede re-enrollment; missing chronology is not authority.
    const clear = cps.every(cp => {
      if (cp === current) return true;
      if (!['withdrawn', 'completed', 'unaligned'].includes(cp.status)) return false;
      const ended = Date.parse(cp.disenrollment_date || cp.end_date || '');
      return Number.isFinite(start) && Number.isFinite(ended) && ended < start;
    });
    if (!clear) { ambiguous.push(uid); continue; }
    selected.push(current);
  }
  return { periods: selected, ambiguous };
}

export function careTeamTaskInScope(task, periods) {
  return periods.some(cp => String(cp.care_period_id) === String(task.id_care_period ?? task.care_period_id ?? '')
    && String(cp.withings_user_id) === String(task.withings_user_id));
}

export function careTeamSnoozed(task, now = Date.now()) {
  if (String(task.template_code || '').startsWith('exc_')) return false;
  let ctx = task.context_json;
  if (typeof ctx === 'string') { try { ctx = JSON.parse(ctx); } catch { return false; } }
  const until = Date.parse(String(ctx?.snooze?.until || '').slice(0, 10));
  const today = Date.parse(new Date(now).toISOString().slice(0, 10));
  return Number.isFinite(until) && until >= today;
}
